<template>
  <nav class="navigation">
    <ol
      v-if="list && list.length"
      class="navigation__tabs"
    >
      <li
        class="navigation__tabs__tab navigation__tabs__tab--compressor"
        @click.stop="isNavigationCompressed = !isNavigationCompressed"
      >
        <div>
          <font-awesome-icon :icon="computedNavigationIcon" />
        </div>
      </li>
      <li
        v-for="item in list"
        :key="item.value"
        :class="{'navigation__tabs__tab--selected': item.value === selectedItem}"
        :title="item.label"
        class="navigation__tabs__tab"
        @click.stop="selectedItem = item.value"
      >
        <div>
          <font-awesome-icon :icon="item.icon" />
        </div>
        <div
          v-if="!isNavigationCompressed"
          class="navigation__tabs__tab__label"
        >
          {{ item.label }}
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

export default {
  name: "NavigationElement",
  components: {
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    list: {
        type: Array,
        default() {
        return [{
          label: 'Water',
          value: 'water',
          icon: ['fas', 'water'],
        }]
      }
    }
  },
  data() {
    return {
      isNavigationCompressed: false,
      selectedItem: null
    }
  },
  computed: {
    computedNavigationIcon() {
      return this.isNavigationCompressed
      ? ['fas', 'expand-arrows-alt']
      : ['fas', 'compress-arrows-alt']
    }
  },
  watch: {
    list() {
      this.selectedItem = this.list && this.list.length ? this.list[0].value : null
    },
    selectedItem() {
      this.$emit('navigationSelectedItem', this.selectedItem)
    }
  }
}
</script>

<style lang="scss">
.navigation {
  &__tabs {
    background-color: $color-blue-dusty;
    height: 100%;

    &__tab {
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 55px 1fr;
      text-transform: capitalize;
      font-size: 18px;
      padding: 10px;
      cursor: pointer;
      transition: 0.5s;

      color: $color-white;

      div{
        &:first-child {
          text-align: center;
        }
        &:last-child {
          font-size: 15px;
        }
      }

      &--selected {
        background-color: $color-blue-marine;
        color: $color-white;
      }

      &--compressor {
        background-color: transparent;
        color: $color-blue-marine;
        div {
          text-align: center;
        }
      }
    }
  }
}
</style>
